import axios from 'axios';

export default axios.create({
  baseURL: `https://meeting-back.herokuapp.com/meeting`,
  // baseURL: `http::127.0.0.1:3000/meeting`,
});
